
import { mapState } from 'vuex';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.BuyButton',
  name: 'BuyButton',
  props: {
    label: {
      type: String,
      required: true
    },
    productUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    buyButtonStyle() {
      return {
        '--btn-bg-color': this.reviewSettings.main_color
      };
    }
  }
};
